const formNames = {
    contact: 'salesReq',
    request: 'reqForQuote',
};

export { formNames };
